// src/wsRecovery/wsResume.js

// English comments only in this code block

/**
 * Placeholder for WS resume logic.
 * For now it does nothing.
 * Real implementation will be added later.
 */
const resumeRegistry = new Map(); 

export function registerSocket(key, resumeFn) {
  resumeRegistry.set(key, resumeFn);
}

export function unregisterSocket(key) {
  resumeRegistry.delete(key);
}

export function resumeAll() {
  console.log("[WS Resume] Running resumeAll...");
  resumeRegistry.forEach((resumeFn, key) => {
    try {
      resumeFn();
    } catch (err) {
      console.error(`[WS Resume] Error in resume for ${key}:`, err);
    }
  });
}

export function clearResumeRegistry() {
  resumeRegistry.clear();
}